export enum DateFormats {
  DEFAULT = 'DD, MMM YYYY',
  WITH_DOTS = 'DD.MM.YYYY',
  WITH_DASHES = 'DD-MM-YYYY',
  DAY_MONTH_WITH_TIME = 'DD MMM, HH:mm',
  DATE_WITH_TIME_WORDS = 'DD MMMM, HH:mm',
  FULL_DATE_WITH_TIME = 'DD MMM, YYYY, HH:mm',
}
